import { Box } from "@radix-ui/themes";
import { Navbar } from "../components/Navbar";
import { Countdown } from "../components/Countdown.tsx";
import { Discord } from "../components/Discord.tsx";

function Home() {
  return (
    <Box className="ro-hero">
      <Navbar />
      {/* role="status" so a screen reader announces the race time rather than
          leaving it as a decorative heading. Casing is preserved in the markup
          and uppercased in CSS, matching the rest of the display type. */}
      <div className="ro-banner" role="status">
        <span className="ro-banner-text ro-chrome">Next Race At Noon!</span>
      </div>
      <Countdown />
      <div className="ro-hero-center">
        <h1 className="ro-hero-title ro-chrome ro-flare" aria-label="Reality Overrun">
          REALI7Y OVERRUN
        </h1>
        <p className="ro-hero-tagline">Shall we play a game?</p>
      </div>
      <Discord />
    </Box>
  );
}

export default Home;
